import { useVenue } from "providers/venue"
import { useMemo } from "react"
import _ from "lodash"
import { getOccupantDetail } from "utils/feature"

export const useOccupantPromotion = (occupantId) => {
  const { findFeatureById, dataLoaded } = useVenue()
  const occupant = useMemo(
    () => (dataLoaded ? findFeatureById(occupantId) : null),
    [occupantId, findFeatureById, dataLoaded]
  )
  const {
    name: occupantName,
    venueLogo,
    promotions,
  } = useMemo(
    () =>
      occupant
        ? getOccupantDetail(occupant)
        : { name: "", venueLogo: "", promotions: [] },
    [occupant]
  )

  const parsedPromotions = useMemo(
    () =>
      promotions.map((promotion) => _.omit(promotion, ["properties.venue"])),
    [promotions]
  )

  const sortedPromotions = useMemo(
    () =>
      _.orderBy(
        parsedPromotions,
        [
          "properties.is_featured",
          "properties.start_date",
          "properties.end_date",
        ],
        ["desc", "asc", "asc"]
      ),
    [parsedPromotions]
  )

  return { occupantName, venueLogo, promotions: sortedPromotions }
}
